import Axios from "axios";
import jwtDecode from "jwt-decode";
import { url } from "../../Config/Config";
import {
  ADMIN_LOGIN,
  ADMIN_LOGOUT,
  USER_LOGIN,
  USER_LOGOUT,
} from "../Types/types";

export const adminLogin = (token, refreshToken, role) => (dispatch) => {
  dispatch({
    type: ADMIN_LOGIN,
    payload: token,
    role: role ? role : "admin",
    refreshToken: refreshToken,
  });
};

export const adminLogout = () => (dispatch) => {
  dispatch({
    type: ADMIN_LOGOUT,
  });
};

export const userLogin = (userId, token, refreshToken, role) => (dispatch) => {
  dispatch({
    type: USER_LOGIN,
    userId: userId,
    payload: token,
    role: role,
    refreshToken: refreshToken,
  });
};

export const userLogout = () => (dispatch) => {
  dispatch({
    type: USER_LOGOUT,
  });
};

export const getAdminRefreshToken =
  (refreshToken, role) => async (dispatch) => {
    const response = await Axios.post(
      `${url}/api/admin/refresh-token`,
      refreshToken
    );
    if (response.data.accessToken && response.data.refreshToken) {
      dispatch({
        type: ADMIN_LOGIN,
        payload: response.data.accessToken,
        refreshToken: response.data.refreshToken,
        role: role ? role : "admin",
      });
    }
  };

export const getUserRefreshToken = (refreshToken, role) => async (dispatch) => {
  if (role === "Student") {
    const response = await Axios.post(
      `${url}/api/login/student/ref`,
      refreshToken
    );

    if (response.data.accessToken && response.data.refreshToken) {
      let decodedData = jwtDecode(response.data.accessToken);
      dispatch({
        type: USER_LOGIN,
        userId: decodedData.aud,
        payload: response.data.accessToken,
        refreshToken: response.data.refreshToken,
        role: role,
      });
    }
  } else if (role === "Parent") {
    const response = await Axios.post(
      `${url}/api/login/parent/ref`,
      refreshToken
    );
    if (response.data.accessToken && response.data.refreshToken) {
      let decodedData = jwtDecode(response.data.accessToken);
      dispatch({
        type: USER_LOGIN,
        userId: decodedData.aud,
        payload: response.data.accessToken,
        refreshToken: response.data.refreshToken,
        role: role,
      });
    }
  } else {
    const response = await Axios.post(
      `${url}/api/login/teacher/ref`,
      refreshToken
    );
    if (response.data.accessToken && response.data.refreshToken) {
      let decodedData = jwtDecode(response.data.accessToken);
      dispatch({
        type: USER_LOGIN,
        userId: decodedData.aud,
        payload: response.data.accessToken,
        refreshToken: response.data.refreshToken,
        role: role,
      });
    }
  }
};
